export enum TrialType {
  NO_DATA_LAG = 'NO_DATA_LAG',
  NO_DATA_LAG_WITH_TD_REVEAL = 'NO_DATA_LAG_WITH_TD_REVEAL',
  ONE_YEAR_DATA_LAG = 'ONE_YEAR_LAG',
}
